import { ReturnCustIndicatorTypes } from '../../constants.js'

const objFunc = () => {
  return {
    email: '',
    cellPhoneNumber: '',
    firstName: '',
    middleName: '',
    lastName: '',
    suffixName: '',
    address: '',
    optionalAddress: '',
    city: '',
    zip: '',
    state: '',
    mailingAddress: '',
    mailingOptionalAddress: '',
    mailingCity: '',
    mailingZip: '',
    mailingState: '',
    addressSameAsMailingAddress: false,
    dateOfBirth: '',
    isCustomerInBankruptcy: undefined,
    userName: '',
    maritalStatus: '',
    idSelection: undefined,
    idNumber: '',
    idState: '',
    idExpiration: '',
    race: '',
    weight: '',
    height: '',
    sex: undefined,
    requestedAmount: undefined,
    tin: '',
    noTin: false,
    alienRegistrationNumber: '',
    activeDuty: undefined,
    optIn: {
      call: false,
      sms: false,
      email: false
    },
    referencesList: [],
    referencesIndex: undefined,
    selectedRetailStore: undefined,
    applicationId: '',
    applicationStatus: undefined,
    customerId: '',
    appraisalStatus: undefined,
    appraisalId: '',
    identityVerified: false,
    applicationSubmitted: false,
    approvedAmount: 0,
    phoneNumberVerified: false,
    signatureName: '',
    customerAddressGeoChecked: false,
    idStateGeoChecked: false,
    newCustomer: true,
    trafficChannel: '',
    invitationCode: '',
    shortFormLoanType: '',
    language: '',
    hasTitle: false,
    hasTitleWithLender: false,
    allowSelfAppraisal: undefined,
    referralCode: '',
    employmentPerWeek: undefined,
    employmentLength: undefined,
    customerHasSeenCppVideo: false,
    loanProduct: undefined,
    routingNum: undefined,
    accountNum: undefined,
    confirmAccountNum: undefined,
    tosAccepted: false,
    bankAccountEntryStatus: undefined,
    bankName: undefined,
    mlvVerified: false,
    newCustomerForAnalytics: false,
    scanIdBarcodeData: '',
    ccfiStoreNumber: undefined,
    returnCustIndicator: ReturnCustIndicatorTypes.empty,
    scanIdData: { // In order to determine is manual or scanned data is overwritten store scanned values
      firstName: undefined,
      middleName: undefined,
      lastName: undefined,
      suffixName: undefined,
      dateOfBirth: undefined,
      address: undefined,
      zip: undefined,
      city: undefined,
      state: undefined,
      weight: undefined,
      height: undefined,
      sex: undefined,
      idSelection: undefined,
      idState: undefined,
      idNumber: undefined,
      idExpiration: undefined
    },
    custLoanTypeSelection: 0,
    existingFlexLoan: undefined,
    leadId: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
